import { GNS } from './GNS.js';

/**
 * GNS.Event
 * 
 * イベントオブジェクトの基底クラス
 * 各種イベントタイプの定数を定義
 * 
 * イベントタイプ:
 * - LOAD, UNLOAD: ページロード関連
 * - RESIZE: リサイズ
 * - CHANGE, COMPLETE: 状態変更
 * - FOCUS, BLUR: フォーカス関連
 * など
 */
GNS.Event = function (a) {
    var b = a.create();
    return b._static.FOCUS = "focus", b._static.BLUR = "blur", b._static.UPDATE = "update", b._static.CHANGE = "change",
        b._static.SELECT = "select", b._static.SUBMIT = "submit", b._static.RESET = "reset", b._static.ABORT = "abort", b
            ._static.ERROR = "error", b._static.LOAD = "load", b._static.DOM_LOAD = "dom_load", b._static.UNLOAD = "unload", b
                ._static.RESIZE = "resize", b._static.COMPLETE = "complete", b.init = function (a, b) {
                    this.type = a, this.params = b
                }, b.toString = function () {
                    return "Event :: type -> " + this.type
                }, b._self
}(GNS);
